// src/services/analyticsApi.js
import apiService from './apiService';

const analyticsApi = {
  // ── Self: booking / consultation analytics ─────────────────────────────────
  getMyBookings: () => apiService.get('/analytics/my-bookings'),

  // ── Admin: booking & specialist analytics ──────────────────────────────────
  getAdminBookings: () => apiService.get('/analytics/bookings'),

  // ── Admin: platform-wide waste analytics ──────────────────────────────────
  getAdminWaste: () => apiService.get('/analytics/waste'),

  // ── Farmer / waste-collector: self waste analytics ────────────────────────
  getMyWaste: () => apiService.get('/analytics/my-waste'),

  // ── Self: subscription & spend history ──────────────────────────────────────
  getMySubscription: () => apiService.get('/analytics/my-subscription'),

  // ── Admin: platform-wide subscription & revenue analytics ──────────────────
  getAdminSubscriptions: () => apiService.get('/analytics/subscriptions'),
};

export default analyticsApi;

